import { Typography } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import isNil from 'lodash/isNil'
import { ReactElement } from 'react'

import { formatSignedPercentage } from '../../../../../../utils/formatSignedPercentage'
import { EMPTY_VALUE_PLACEHOLDER } from '../../../../constants/emptyValuePlaceholder'

interface ProfitAndLossPercentageProps {
  value?: number | null
}

export const ProfitAndLossPercentage = ({ value }: ProfitAndLossPercentageProps): ReactElement => {
  if (isNil(value)) {
    return <Typography.Text>{EMPTY_VALUE_PLACEHOLDER}</Typography.Text>
  }

  return (
    <Typography.Text color={value < 0 ? colors.content.danger.bold : undefined}>
      {formatSignedPercentage(value)}
    </Typography.Text>
  )
}
